import React from "react";

import PropTypes from "prop-types";

import numberFormat from "common/source-function/numberFormat";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaCheckCircle } from "components/atoms/Icon/fa/FaCheckCircle";

import styles from "./Index.module.scss";

const AccountingTab = ({
  accountingService,
  setAccountingValue,
  accountingValue,
}) => {
  const transaction = accountingService.types[0]?.transaction || {};

  return (
    <>
      <div>
        <div className="mb-6 text-center lg:mb-8">
          <ButtonNew>Accounting</ButtonNew>
        </div>
      </div>
      <div className="mb-6 flex items-center justify-center gap-x-7">
        <input
          className="h-8 w-20 rounded-full border border-bbc-neutral-600 text-center outline-none"
          value={numberFormat(accountingValue)}
          onChange={(e) => setAccountingValue(e.target.value)}
        />
        <p>Transactions per month</p>
      </div>
      <div className="mb-0 border-0 lg:mb-6 lg:border-b lg:px-6">
        <input
          className={`form-input mb-4 h-1 w-full appearance-none rounded-full bg-bbc-primary focus:shadow-none focus:outline-0 focus:ring-0 ${styles.sfc_slider}`}
          min={transaction.min || 1}
          max={transaction.max || 1000}
          step={transaction.step || 1}
          value={accountingValue}
          onChange={(e) => setAccountingValue(e.target.value)}
          type="range"
        />
        <div className="mb-6 flex justify-between">
          <span>{numberFormat(transaction.min || 1)}</span>
          <span>{numberFormat(transaction.max || 1000)}</span>
        </div>
        <div className="flex flex-col items-center gap-y-3 md:flex-row ">
          <p className="pb-0 text-center lg:pb-4">
            * Greater than 90 transactions per month? Please contact us.
          </p>
        </div>
      </div>
      <div className="hidden px-6 lg:block">
        <p className="mb-6 text-lg font-semibold text-bbc-brand-700">
          What&lsquo;s included in Accounting package?
        </p>
        <ul>
          <li className="mt-2 mb-2 flex items-start first:mt-0">
            <div>
              <FaCheckCircle
                className="mr-2.5 mt-1 block text-bbc-brand-600"
                size={16}
              />
            </div>
            <span>Monthly/quarterly and yearly tax preparation</span>
          </li>
          <li className="mt-2 mb-2 flex items-start first:mt-0">
            <div>
              <FaCheckCircle
                className="mr-2.5 mt-1 block text-bbc-brand-600"
                size={16}
              />
            </div>
            <span>Bookkeeping service and FSs compilation</span>
          </li>
          <li className="mt-2 flex items-start first:mt-0">
            <FaCheckCircle
              className="mr-2.5 mt-1 block text-bbc-brand-600"
              size={16}
            />
            <span>Appointment of Chief Accountant</span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default AccountingTab;

AccountingTab.propTypes = {
  accountingService: PropTypes.object,
  setAccountingValue: PropTypes.func,
  accountingValue: PropTypes.any,
  xero: PropTypes.object,
  setXero: PropTypes.func,
};

AccountingTab.defaultProps = {
  accountingService: {},
  setAccountingValue: () => {},
  accountingValue: "",
  xero: {},
  setXero: () => {},
};
